import React, { useEffect, useState } from 'react';
import Script from 'next/script';
import { useChat } from '$shared/components';
import { useMobileMenu } from '$features/navigation/components/_N35MobileMegaMenu';
// import { useFilterUIState } from '$features/productsList/hooks';
import { StyledChatButton, StyledChatButtonContainer } from './styled';
import ZendeskBubble from '$icons/zendesk-bubble.svg';

export const ZendeskV1Api = ({ zendeskScriptSource }: { zendeskScriptSource: string }) => {
    const { setChatError } = useChat();
    const [initialized, setInitialized] = useState<boolean>(false);
    const { isOpen: isMobileMenuOpen } = useMobileMenu();

    const toggleChatState = (state: 'hide' | 'show' | 'open' | 'close' = 'show') => {
        const { zE } = window;
        if (zE) {
            zE('messenger', state);
        }
    };

    const handleZendeskScriptError = (e: Error) => {
        setChatError(e);
    };

    const handleZendeskScriptLoaded = () => {
        // When scripts is loaded, zE should be available on window
        const { zE } = window;
        if (!zE) {
            // Zendesk catches, we show notification
            const error = new Error('Could not find "zE" of Zendesk');
            setChatError(error);
            throw error;
        }
        toggleChatState('open');
    };

    useEffect(() => {
        if (isMobileMenuOpen) {
            toggleChatState('hide');
        }
    }, [isMobileMenuOpen]);

    if (!initialized) {
        return (
            <StyledChatButtonContainer>
                <StyledChatButton
                    onClick={() => setInitialized(true)}
                    aria-label="Open messaging window"
                    showHoverIndicator={false}
                >
                    <ZendeskBubble />
                </StyledChatButton>
            </StyledChatButtonContainer>
        );
    }

    return (
        <Script
            onLoad={handleZendeskScriptLoaded}
            onError={handleZendeskScriptError}
            id="ze-snippet"
            src={zendeskScriptSource}
            async
            defer
        />
    );
};
